export default {

    state: {
    },

    mutations: {
        setPerms(state, perms) {
            Object.assign(state, perms);
        },
    },

};